module.exports = __webpack_public_path__ + "img/qrcode.6f18cb01.png";